import type { IAutocompleteWebsiteItemDetails } from "@similarweb/ui-components";

import type { Recent } from "app/custom-hooks/useRecentsHook";

export const getWebsiteDomains = (item: Recent) => {
    const mainSite: IAutocompleteWebsiteItemDetails = {
        domain: item.data.mainItem,
        iconUrl: item.data.resources.mainItemFavIcon,
    };

    let compareSites: IAutocompleteWebsiteItemDetails[];

    if (item.data.comparedItems && !!item.data.comparedItems.length) {
        compareSites = item.data.comparedItems?.map((comp, i) => ({
            domain: comp,
            iconUrl: item.data.resources.comparedItemsFavicon[i],
        }));
    }

    return { mainSite, compareSites };
};
